module.exports = __webpack_public_path__ + "img/bg.a3042425.png";